import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-50" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-51" data-mp="c6ivdvtic587">
        <h2 className="text-lg font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-52" data-mp="c7k8e5u331sk">
          One last question
        </h2>
        <p className="mt-1 text-sm leading-snug text-white/90 sm:text-base" data-id="element-53" data-mp="87jq2a3v66g8">
          When you're looking at an unfamiliar tissue, organ, or pathological
          pattern... Do you immediately know what features you should be
          looking for? Stop jumping between scattered references and memorizing
          microscopic images without understanding what actually separates one
          pattern from another. See the tissue. Spot the features. Compare the
          differences. Recognize the pattern.
        </p>
        <p className="mt-1 font-heading text-xs font-extrabold uppercase tracking-wide text-blush sm:text-sm" data-id="element-54" data-mp="zwvabqn6728a">
          See. Spot. Compare. Recognize.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[300px]" data-id="element-55" data-mp="2c6rbsam3yip6" />

        <p className="mt-2 font-heading text-base font-extrabold uppercase text-white sm:text-2xl" data-id="element-56" data-mp="2h49jjxoe2rvl">
          🔬 HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™
        </p>
        <p className="mt-0.5 font-heading text-[0.65rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-57" data-mp="2r2786ma5uqoq">
          The Complete Visual Study System for Histology &amp; Pathology Students
        </p>
        <p className="mt-0.5 font-heading text-[0.65rem] font-bold uppercase tracking-widest text-electric sm:text-xs" data-id="element-58" data-mp="301k7im4klyvq">
          Visualize • Identify • Compare • Differentiate • Recognize • Review
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-59" data-mp="39r3spyfra4tr">
          <p className="font-heading text-xs font-extrabold uppercase tracking-wide text-blush sm:text-sm" data-id="element-60" data-mp="3eri2pm0x3ouf">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-61" data-mp="3itd1ojvdlq51">
            <CTAButton label="⚡ GET HISTOLOGY & PATHOLOGY VISUAL ATLAS™" data-id="element-62" data-mp="1jo3ixlea4d5m" />
          </div>
          <p className="mt-2 text-[0.65rem] font-bold uppercase tracking-wide text-white/80 sm:text-xs" data-id="element-63" data-mp="1ep8qdrqifa8b">
            Immediate Access • Digital Delivery 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}